import baseService from './baseService';

export const getPayments = (page, perPage, searchTerm, payoutPageFilter) =>
  baseService.get('/member/payouts', {
    params: {
      page,
      per_page: perPage,
      search_term: searchTerm,
      payout_status: payoutPageFilter,
    },
  });
